import { useSelector, useDispatch } from 'react-redux';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { closeMessage } from '../redux/appMainSlice';

const messageComponent = function ShowMessage() {
    const dispatch = useDispatch();
    
    // Redux state selectors
    const message = useSelector(state => state.appMain.message);
    
    // Redux actions
    const closeMessageAction = () => dispatch(closeMessage());

    if(!message)
        return null;

    function handleClose(event, reason) {
        if (reason === 'clickaway') {
            return;
        }
        closeMessageAction();
    }

    // Determine message type and content
    const messageText = typeof message === 'string' ? message : message?.message || 'An error occurred';
    const messageType = message?.type || (typeof message === 'string' ? 'info' : message?.severity || 'info');

    return (
        <Snackbar
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={true}
            autoHideDuration={4000}
            onClose={handleClose}
            sx={{
                '& .MuiSnackbar-root': {
                    top: '20px !important',
                    right: '20px !important',
                },
            }}
        >
            <Alert
                id="message-id"
                onClose={handleClose}
                severity={messageType}
                sx={{
                    width: '100%',
                    fontSize: '0.95rem',
                    fontWeight: 500,
                    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
                    borderRadius: '8px',
                    animation: 'slideIn 0.3s ease-out',
                    '@keyframes slideIn': {
                        from: {
                            transform: 'translateX(400px)',
                            opacity: 0,
                        },
                        to: {
                            transform: 'translateX(0)',
                            opacity: 1,
                        },
                    },
                    '& .MuiAlert-icon': {
                        fontSize: '1.4rem',
                    },
                    '& .MuiAlert-message': {
                        lineHeight: 1.5,
                    },
                }}
                action={
                    <IconButton
                        size="small"
                        aria-label="close"
                        color="inherit"
                        onClick={handleClose}
                        sx={{
                            ml: 1,
                            '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.05)',
                            },
                        }}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                }
            >
                {messageText}
            </Alert>
        </Snackbar>
    );
}

export default messageComponent;